module.exports = __webpack_public_path__ + "static/media/covid19app.88117a78.png";